import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DeviceDataTypesService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}devicedatatypes/listAll`).then((data) => {
        resolve({ deviceDataTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default DeviceDataTypesService;
